// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  priismApptApiEndPoint: "http://localhost:5001/v1",
  priismApiEndPoint: "http://localhost:5000/v1",
  priismApiAuthToken: "your_api_key_2",
  // Razorpay public Key IDs — safe to commit; they ship in the browser bundle by design.
  // Secrets (Key Secret, webhook secret) must live on the backend, never here.
  razorpayKeyId: "rzp_test_vadRV0NSlVKaHK",
  razorpayKeyIdManoshanti: "rzp_test_vadRV0NSlVKaHK",
  razorpayKeyIdSthira: "rzp_test_vadRV0NSlVKaHK"
};
